import styles from "./RangeCalendar.module.scss";
import { Calendar } from "primereact/calendar";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { classNames } from "primereact/utils";
import { useAppContext } from "../../../../../AppContext";

interface IRangeCalendar {
  dateFromName: string;
  dateToName: string;
  maxDate?: Date;
  minDate?: Date;
  width?: string;
  label?: string;
  required?: boolean;
}
export const RangeCalendar = ({
  dateFromName,
  dateToName,
  maxDate,
  minDate,
  width,
  label,
  required,
}: IRangeCalendar) => {
  const [dates, setDates] = useState<Date[] | null>(null);
  const { setValue, getValues } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = "80%";
    }
  }

  useEffect(() => {
    const initialDateFrom = getValues(dateFromName) || new Date();
    const initialDateTo = getValues(dateToName) || new Date();

    setDates([initialDateFrom, initialDateTo]);
  }, [dateFromName, dateToName, getValues]);

  useEffect(() => {
    if (dates && dates.length === 2) {
      setValue(dateFromName, dates[0]);
      setValue(dateToName, dates[1]);
    }
  }, [dates, dateFromName, dateToName, setValue]);

  return (
    <div style={{ width: width }} className={styles.root}>
      <RenderWhen condition={!!label}>
        <div className={classNames(styles.root_label)}>
          {label}
          {required ? "*" : ""}
        </div>
      </RenderWhen>
      <Calendar
        className={styles.root_calendar}
        value={dates}
        onChange={(e) => setDates(e.value as Date[] | null)}
        selectionMode="range"
        readOnlyInput
        maxDate={maxDate}
        minDate={minDate}
        hideOnRangeSelection
        locale="bg"
      />
    </div>
  );
};
